$(window).on('showByStep', (event, speed) => {
  const $showItem = $('[data-show-by-step]');

  const hold = speed || 200;

  $.each($showItem, (i, t) => {
    const $this = $(t);

    setTimeout(() => {
      $this.addClass('shown');
    }, i * hold);
  });
});

$(() => {
  const $showItemWrap = $('[data-show-by-step-wrap]');
  const elWatcher = scrollMonitor.create($showItemWrap, { top: -100 });

  elWatcher.enterViewport(() => {
    $(window).trigger('showByStep');
  });
});



// WEBPACK FOOTER //
// ./src/scripts/components/show-by-step/index.js